export default __webpack_public_path__ + "static/media/img2.82b162f7.JPG";